import { render, staticRenderFns } from "./ClientVideoItem.vue?vue&type=template&id=704b1e1c&scoped=true&"
import script from "./ClientVideoItem.vue?vue&type=script&lang=js&"
export * from "./ClientVideoItem.vue?vue&type=script&lang=js&"
import style0 from "./ClientVideoItem.vue?vue&type=style&index=0&id=704b1e1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b1e1c",
  null
  
)

export default component.exports